import { SELECT_MOB } from "redux/action-types/SelectMob";

export const selectMob = (payload) => ({
    type: SELECT_MOB,
    payload
});